import { StationeryTemplate } from './DesignsGallery.types';
import { useApplySearchFiltersToTemplates } from './useApplySearchFiltersToTemplates';
import { useActivePrintFiltersVar } from './utils/activePrintFiltersCache';

export const useApplyFiltersToTemplates = (templates: StationeryTemplate[]) => {
  const activePrintFilters = useActivePrintFiltersVar();
  const { applySearchFiltersToTemplates, useSearchResults, searchError } = useApplySearchFiltersToTemplates();
  const searchResults = useSearchResults();

  if (searchResults.searchCompleted) {
    templates = applySearchFiltersToTemplates(templates);
  }

  if (activePrintFilters.size === 0) {
    return templates;
  }

  const filtered = templates.filter(template => {
    return template.mappedTags.some(tagCompositeCode => activePrintFilters.has(tagCompositeCode));
  });

  if (filtered.length === 0 && searchResults.searchCompleted) {
    searchError();
    return templates;
  }

  return filtered;
};
